module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[30]517.14d4d83.woff2";